import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { api, fmtError } from "../api";

export default function ResetPassword() {
  const [sp] = useSearchParams();
  const nav = useNavigate();
  const token = sp.get("token") || "";
  const [pw, setPw] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      nav("/login", { replace: true });
    } catch (e) { setErr(fmtError(e.response?.data?.detail) || e.message); }
    finally { setBusy(false); }
  };

  return (
    <div className="login-screen" data-testid="reset-screen">
      <div className="login-bg" />
      <form className="login-box" onSubmit={submit}>
        <div className="login-logo">Admatik <span>Rmax</span></div>
        <div className="login-tagline">Set New Password</div>
        {err && <div className="login-error">{err}</div>}
        <div className="form-group">
          <div className="login-label">New Password</div>
          <input className="login-input" type="password" required minLength={8}
            value={pw} onChange={(e) => setPw(e.target.value)} data-testid="reset-password" />
        </div>
        <button className="login-btn" type="submit" disabled={busy || !token} data-testid="reset-submit">
          {busy ? "Resetting..." : "Reset Password"}
        </button>
        <div style={{ textAlign: "center" }}>
          <Link className="login-link" to="/login">← Back to login</Link>
        </div>
      </form>
    </div>
  );
}
